define('lib/controller/BaseController',['require','marionette','view/layout/EmptyLayout','Config'],function (require) {

	var Marionette = require('marionette');
	var EmptyLayout = require('view/layout/EmptyLayout');
	var Config = require('Config');
	/**
	 * Base controller class
	 *
	 * @class BaseController
	 */
	return Marionette.Object.extend({

		_app: null,
		_root: null,
		_layout: null,

		/**
		 * Inits instance
		 */
		initialize: function() {
			this._app = this.getOption('app');
            this._root = this.getOption('root');
			this._layout = this.getOption('layout');
		},

		setLayout: function (layout) {
			this._layout = layout;
		},

		getMainLayout: function () {
			if(Config.getInstance().getOption('show_empty_layout')){
				return  this.getEmptyLayout();
			}
			var layout = this._layout || this._app.getLayout();

			if (this.getRootRegion()) {
                this.getRootRegion().show(layout);
			}

			return layout;
		},

		getEmptyLayout: function () {
            var layout = new EmptyLayout();

            if (this.getRootRegion()) {
            	// preventDestroy means do not destroy previous view. we need it to now destroy main layout.
                this.getRootRegion().show(layout, {
                    preventDestroy: true
                });
            }

            return layout;
		},

        getRootRegion: function () {
            return this._app.getRootRegion();
        },

		_redirect: function (path, options) {
			if (_.isUndefined(options)) {
				options = {
					trigger: true
				};
			}
			Backbone.history.navigate(path, options);
		},

		_redirectWithReplace: function (path, options) {
			if (_.isUndefined(options)) {
				options = {
					trigger: true,
					replace: true
				};
			}
			Backbone.history.navigate(path, options);
		}

	});

});

